import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';
import dayjs from 'lib/dayjs';
import { useCountDown } from 'ahooks';

const Container = styled.div`
  min-height: 30px;
  background-color: #fffaf0;
  font-size: 12px;
  line-height: 30px;
  padding-left: 12px;
`;
interface Props {
  conversation?: Conversation.Conversation;
}
const WhatsappBillingNotice = (props: Props) => {
  const { conversation } = props;
  const { t } = useTranslate();
  const [, { hours, minutes, seconds }] = useCountDown({
    targetDate: new Date(Number(conversation?.waConvInfo?.expireTime ?? 0)),
  });
  if (!conversation || !conversation?.waConvInfo || !conversation?.waUserInfo) {
    return null;
  }
  const { waConvInfo } = conversation;
  const { costType, price, existConv, expireTime } = waConvInfo;
  const getText = () => {
    if (waConvInfo?.costType === 'FREE') {
      return undefined;
    }
    if (!existConv) {
      return costType === 'COST_FREE_QUOTA'
        ? t(
            'WhatsApp.本次预计消耗一个会话额度，24小时内该会话不会再次扣费，当前用户可能未注册Whatsapp，若发送失败，不会进行扣费',
          )
        : t(
            'WhatsApp.本次预计扣除x点券，24小时内该会话不会再次扣费，当前用户可能未注册Whatsapp，若发送失败，不会进行扣费',
            { x: price },
          );
    }
    const diff = dayjs(Number(expireTime)).diff(dayjs(), 'second');
    if (diff <= 0) {
      return costType === 'COST_FREE_QUOTA'
        ? t('WhatsApp.本次预计消耗一个会话额度，24小时内该会话不会再次扣费')
        : t('WhatsApp.本次预计扣除x点券，24小时内该会话不会再次扣费', { x: price });
    }
    if (diff <= 60 * 60) {
      return t('WhatsApp.本次会话将在x后重新扣费', {
        x: ` ${hours}:${minutes}:${seconds} `,
      });
    }
    return undefined;
  };
  const text = getText();
  if (!text) {
    return null;
  }

  return <Container>{text}</Container>;
};

export default WhatsappBillingNotice;
